import { createContext, useReducer } from 'react';
import { settings, initialStateSettings } from './reducerTestSettings.js';
import { posts, initialPostsContext } from './reducerPosts';
import { routingResponse, versionResponse, responseSimulation, initialRoutingResponse, initialVersionResponse, initialResponseSimulation } from './reducerResponses';
import { env } from './reducerTestEnv';
import { testCriteria, initialStateContext } from './reducersTestCriteria';
import { calculator, initialStateCalculator } from './reducerCalculator';
import { loading, initialLoadingContext } from './reducerLoading';
import { widget, initialStateWidget } from './reducerWidget';
import HelperEnv from '../helpers/HelperEnv';

export const ReducerContext = createContext(null);
export const ReducerDispatchContext = createContext(null);

const initialState = {
  isInitialised: false,
  settings: initialStateSettings,
  testCriteria: { context: initialStateContext, vehicle: {} },
  env: HelperEnv.getPathEnvVariables(),
  posts: initialPostsContext,
  loading: initialLoadingContext,
  widget: initialStateWidget,
  routingResponse: initialRoutingResponse,
  versionResponse: initialVersionResponse,
  responseSimulation: initialResponseSimulation,
  calculator: initialStateCalculator
};

const reducer = (state, action) => {
  const settingsState = settings(state.settings, action);
  const testCriteriaState = testCriteria(state.testCriteria, action);
  const envState = env(state.env, action);
  const postsState = posts(state.posts, action);
  const loadingState = loading(state.loading, action);
  const routingResponseState = routingResponse(state.routingResponse, action);
  const versionResponseState = versionResponse(state.versionResponse, action);
  const responseSimulationState = responseSimulation(state.responseSimulation, action);
  const calculatorState = calculator(state.calculator, action, testCriteriaState.context);
  const widgetState = widget(state.widget, action);
  state = {
    ...state, settings: { ...settingsState }, testCriteria: { ...testCriteriaState }, env: { ...envState },
    posts: { ...postsState },
    loading: { ...loadingState }, widget: { ...widgetState },
    routingResponse: { ...routingResponseState }, versionResponse: { ...versionResponseState }, responseSimulation: { ...responseSimulationState },
    calculator: { ...calculatorState },
    isInitialised: true
  }
  return state;
};


export function ReducerContextProvider({ children }) {
  const [tasks, dispatch] = useReducer(reducer, initialState);
  return (
    <ReducerContext.Provider value={tasks}>
      <ReducerDispatchContext.Provider value={dispatch}>
        {children}
      </ReducerDispatchContext.Provider>
    </ReducerContext.Provider>
  );
}
